export default __webpack_public_path__ + "static/media/sfondohome.a6c55c4b.jpg";